import React, { FC } from 'react'
import { fillArray, iconPath } from '@ui/helpers'
import css from 'styled-jsx/css'

type PaginationProps = {
  total: number
  perPage: number
  active?: number
  onPageChanged: (active: number) => void
  className?: string
}
const Pagination: FC<PaginationProps> = ({ active = 1, ...props }) => {
  const pageNums = Math.floor((props.total - 1) / props.perPage) + 1

  const onClick = (pageNum: number) => () => props.onPageChanged(pageNum)

  const onPrev = () => active > 1 && props.onPageChanged(active - 1)

  const onNext = () => active < pageNums && props.onPageChanged(active + 1)

  return (
    <nav
      className={`pagination is-right ${props.className}`}
      role="navigation"
      aria-label="pagination"
    >
      <style jsx>{scopedStyle}</style>
      <ul className="pagination-list">
        <li onClick={onPrev} onKeyDown={onPrev} role="menuitem">
          <a className="pagination-link">
            <img src={iconPath('chevron_left.svg')} alt="Previous page" />
          </a>
        </li>

        {pageNums &&
          fillArray(pageNums).map((idx) => (
            <li key={idx} onClick={onClick(idx)} onKeyDown={onClick(idx)} role="menuitem">
              <a className={`pagination-link ${idx === active ? 'is-active' : ''}`}>{idx}</a>
            </li>
          ))}

        <li onClick={onNext} onKeyDown={onNext} role="menuitem">
          <a className="pagination-link">
            <img src={iconPath('chevron_right.svg')} alt="Next page" />
          </a>
        </li>
        {/* <li><a className="pagination-link" aria-label="Goto page 1">1</a></li>
        <li><span className="pagination-ellipsis">&hellip;</span></li>
        <li><a className="pagination-link" aria-label="Goto page 45">45</a></li>
        <li><a className="pagination-link is-current" aria-label="Page 46" aria-current="page">46</a></li>
        <li><a className="pagination-link" aria-label="Goto page 47">47</a></li>
        <li><span className="pagination-ellipsis">&hellip;</span></li>
        <li><a className="pagination-link" aria-label="Goto page 86">86</a></li> */}
      </ul>
    </nav>
  )
}

const scopedStyle = css`
  .pagination-link {
    font-size: 16px;
    width: 46px;
    height: 46px;
    border-color: #dcdcdc;
    opacity: 0.5;

    &.is-active {
      border-color: #737373;
      opacity: 1;
    }

    img {
      width: 12px;
    }
  }
`

export default Pagination
